import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IGetRowsParams } from 'ag-grid-community';
import { DataRes } from '@shared/models/data-list.t';
import { PacienteRowData } from '@pacientes/models/pacientes-view.models';

export interface VerificarPacienteResponse {
  puede_ser_creado: boolean;
  // Optional server-provided reason shown inline when `puede_ser_creado` is false
  // (e.g. presuntivos duplicados, P02). Absent for pacientes/contactos -> the
  // caller keeps its current generic message (retrocompatible).
  motivo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class Pacientes {
  private http = inject(HttpClient);

  obtenerPacientesView = (params: IGetRowsParams) => {
    return this.http.post<DataRes<PacienteRowData>>('/api/sinhantb/pacientes/view/', params);
  };

  softDeleteCaso = (casoId: number) => {
    return this.http.patch<{ message: string }>(
      `/api/sinhantb/pacientes/${casoId}/delete/`,
      {},
    );
  };

  verificarPaciente = (
    numeroDocumento: string,
    componentLocation: string,
    recordId?: number | null,
  ) => {
    return this.http.post<VerificarPacienteResponse>('/api/sinhantb/pacientes/verificar/', {
      numero_documento: numeroDocumento,
      component_location: componentLocation,
      record_id: recordId ?? null,
    });
  };
}
